import { Platform } from 'react-native'

import CloseIcon from 'app/assets/icons/delete-file-icon.svg'
import Box, { BoxProps } from 'app/components/base/Box'
import IconButton from 'app/components/base/IconButton'
import Spinner from 'app/components/base/Spinner'

interface DeleteButtonProps extends Omit<BoxProps, 'onClick'> {
  onClick: () => void
  loading?: boolean
  size?: number
}

const DeleteButton = ({
  sx,
  onClick,
  loading,
  size = 16,
  ...props
}: DeleteButtonProps) => {
  const handleClick = Platform.select({
    web: { onClick: () => onClick() },
    native: { onPress: () => onClick() }
  })

  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center'
      }}
      {...props}
    >
      {loading ? (
        <Spinner size={size} />
      ) : (
        <IconButton {...handleClick}>
          <CloseIcon viewBox="0 0 27 27" width={size} height={size} />
        </IconButton>
      )}
    </Box>
  )
}

export default DeleteButton
